export const limitDateToRange = (
  date: Date,
  { max, min }: { max?: Date; min?: Date },
): Date => {
  if (min && min > date) {
    return min;
  }
  if (max && max < date) {
    return max;
  }
  return date;
};
